<div
  class="sidebar panel"
  [class.show]="expanded"
  [class.forceOverlay]="forceOverlay"
>
  <div class="sidebar-contents">
    <ng-content></ng-content>
  </div>
</div>
